<section class="pb-0 lg:pb-12" [class.hidden]="!partners().length">
    <span class="lg:text-display-small text-title-large mb-6 flex justify-center">
        {{ partnerBlock().translations_refs | getTranslation: "title" }}
    </span>
    <figure class="flex flex-wrap justify-around gap-4 lg:justify-center xl:gap-12">
        @for (partner of partners(); track partner) {
            @if (partner?.logo) {
                <a [href]="partner?.url" target="_blank">
                    <img
                        [ngSrc]="partner?.logo | getDirectusImage"
                        width="250"
                        height="150"
                        [alt]="partner?.name || 'Partner logo'"
                        class="max-h-26.5 min-h-26.5 max-w-42 min-w-42 object-contain xl:max-h-37.5 xl:min-h-37.5 xl:max-w-62.5 xl:min-w-62.5"
                    />
                </a>
            }
        }
    </figure>
</section>
